import { useCallback, useMemo, useState } from "react";

export type ButtonProps = {
  onClick?: () => void | Promise<void>;
  label: string;
};

export const Button = ({ onClick, label }: ButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const handleClick = useCallback(async () => {
    setIsLoading(true);
    try {
      await onClick?.();
    } catch (e) {
      console.error(e);
      setError("Error - check console");
      setTimeout(() => setError(undefined), 3000);
    }
    setIsLoading(false);
  }, [onClick]);

  const isDisabled = useMemo(() => !onClick || isLoading, [onClick, isLoading]);

  return (
    <button
      type="button"
      className={`mt-4 border border-white border-8 px-16 py-6 transition-all ${isDisabled ? "border-white/20 text-white/20 cursor-not-allowed" : "cursor-pointer hover:bg-white/10"} ${error ? "border-red-500 text-red-500" : ""}`}
      onClick={handleClick}
      disabled={isDisabled}
    >
      <p className="doom text-5xl tracking-wider">{error ? error : isLoading ? "Loading..." : label}</p>
    </button>
  );
};
